import apiClient from './apiClient';

export interface FavouriteDto {
  favouriteId: string;
  favouriteType: string;
  favouriteReference: string;
  favouriteName: string;
  displayOrder?: number;
}

export interface AddFavouriteDto {
  favouriteType: string;
  favouriteReference: string;
  favouriteName: string;
}

const favouritesApi = {
  getFavourites: () =>
    apiClient.get<{ data: FavouriteDto[] }>('/api/favourites'),

  addFavourite: (data: AddFavouriteDto) =>
    apiClient.post<{ data: FavouriteDto }>('/api/favourites', data),

  removeFavourite: (id: string) =>
    apiClient.delete(`/api/favourites/${id}`),

  removeFavouriteByReference: (type: string, reference: string) =>
    apiClient.delete('/api/favourites/by-reference', { params: { type, reference } }),

  reorderFavourites: (items: { favouriteId: string; displayOrder: number }[]) =>
    apiClient.put('/api/favourites/reorder', items),
};

export default favouritesApi;
